<template>
  <div @load="getlocal()">
    <div>
      <el-button @click="PrintRow()" type="primary">打印</el-button>
    </div>
    <div ref="page">
      <div class="paper" v-for="(item, i) in pageList" :key="i">
        <div class="cell">
          <div class="layer-art-cert-vertical">

            <div class="inner">
              <div class="input-text moveable active fontCn" style="left: 136px; top: 440px; font-size: 14pt; font-family: 微软雅黑;">
                <img style="width: 128px;height: 168px" :src="item.photoUrl">
              </div>
              <div class="input-text moveable active fontCn" style="left: 218px; top: 676px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.makeCertificateTime}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 288px; top: 705px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.makeCertificateTime}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 214px; top: 733px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.gradeStartEnd}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 210px; top: 795px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.gradeStartEnd}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 211px; top: 826px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.evaluateCertificateNo}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 189px; top: 858px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.evaluateCertificateNo}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 495px; top: 385px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.examineeName}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 514px; top: 424px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.examineeNameSpell}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 493px; top: 457px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.sex}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 494px; top: 495px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.sexDesc}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 494px; top: 530px; font-size: 14pt; font-family: 微软雅黑;">
                <!--                <span> {{item.country}} </span>-->
                <input class="edit-country" v-model="item.country" placeholder="">
              </div>
              <div class="input-text moveable fontEn" style="left: 590px; top: 567px; font-size: 14pt; font-family: 微软雅黑;">
                <!--                <span> {{item.countryDesc}} </span>-->
                <input class="edit-country" v-model="item.countryDesc" placeholder="">
              </div>
              <div class="input-text moveable fontCn" style="left: 493px; top: 603px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.nationality}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 528px; top: 638px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.nationalityDesc}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 528px; top: 675px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.birthday}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 613px; top: 711px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.birthday}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 528px; top: 748px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.specialtyName}} </span>
              </div>
              <div class="input-text moveable fontEn worktypeEn" style="left: 568px; top: 782px; font-size: 14pt; font-family: 微软雅黑; font-size:auto">
                <span style="white-space: nowrap;"> {{item.specialtyNameDesc}} </span>
              </div>
              <div class="input-text moveable fontCn" style="left: 493px; top: 819px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.gradeName}} </span>
              </div>
              <div class="input-text moveable fontEn" style="left: 525px; top: 856px; font-size: 14pt; font-family: 微软雅黑;">
                <span> {{item.gradeNum}} </span>
              </div>
              <div class="cell" style="left:132px; top:646px;">
                <div class="label">
                  <span class="zh">发证时间</span>
                  <span class="en">date of issue</span>
                </div>
              </div>

              <div class="cell" style="left:132px; top:703px;">
                <div class="label">
                  <span class="zh">起止级</span>
                  <span class="en">grade of beginning &amp; <br>end</span>
                </div>
              </div>

              <div class="cell" style="left:132px; top:786px;">
                <div class="label">
                  <span class="zh">证书编号</span>
                  <span class="en">No.</span>
                </div>
              </div>
              <div class="cell" style="left:423px; top:412px;">
                <div class="label">
                  <span class="zh">姓名</span>
                  <span class="en">name</span>
                </div>
              </div>
              <div class="cell" style="left:423px; top:472px;">
                <div class="label">
                  <span class="zh">性别</span>
                  <span class="en">sex</span>
                </div>
              </div>

              <div class="cell" style="left:423px; top:532px;">
                <div class="label">
                  <span class="zh">国籍</span>
                  <span class="en">nationality</span>
                </div>
              </div>

              <div class="cell" style="left:423px; top:597px;">
                <div class="label">
                  <span class="zh">民族</span>
                  <span class="en">nation</span>
                </div>
              </div>
              <div class="cell" style="left:423px; top:661px;">
                <div class="label">
                  <span class="zh">出生日期</span>
                  <span class="en">date of birth</span>
                </div>
              </div>
              <div class="cell" style="left:423px; top:725px;">
                <div class="label">
                  <span class="zh">考级专业</span>
                  <span class="en">speciality</span>
                </div>
              </div>
              <div class="cell" style="left:423px; top:782px;">
                <div class="label">
                  <span class="zh">等级</span>
                  <span class="en">grade</span>
                </div>
              </div>
              <div class="cell" style="left:423px; top:837px;">
                <div class="label">
                  <span class="zh">成绩</span>
                  <span class="en">score</span>
                </div>
              </div>
              <div class="cell" style="left:423px; top:892px;">
                <div class="label">
                  <span class="zh">证件号码</span>
                  <span class="en">ID number</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tool from '../../common/tool'

export default {
  name: "printing",
  data () {
    return {
      pageList: [],
      multipleSelection: Tool.getStorage('multipleSelection')
    }
  },
  async created () {
    this.getlocal()
  },
  methods: {
    PrintRow (index, row) {
      this.$print(this.$refs.page) // 使用
      const evaluateExamIds = this.multipleSelection.map(item => item.evaluateExamId)
      this.$HTTP.GradeExam.UpdatePrintStatus({ evaluateExamIds })
    },
    async getlocal () {
      let array = Tool.getStorage('multipleSelection')
      for (let i = 0; i < array.length; i++) {
        let info = array[i]
        if (info.officialPhoto != null) {
          if (info.officialPhoto.indexOf("IDCard") != -1) {
            info.photoUrl = await this.$HTTP.ApiOss.signatureUrl(info.officialPhoto, 'IDCard')
          } else {
            info.photoUrl = await this.$HTTP.ApiOss.signatureUrl(info.officialPhoto, 'ID-photo')
          }
        } else {
          info.photoUrl = await this.$HTTP.ApiOss.signatureUrl(info.officialPhoto, 'ID-photo')
        }
      }
      // console.log(array)
      this.pageList = array

    },
    async initForm () {
      if (this.pageList) {
        info.failPhoto2 = await this.$HTTP.ApiOss.signatureUrl(this.pageList[i].failPhoto, 'ID-photo')
        info.officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(info.officialPhoto, 'ID-photo')
        this.form = info
      }
    }
  }
}
</script>

<style scoped>

  body {
    margin: 0 auto;
    -webkit-print-color-adjust: exact;
    font-family: SimSun;
    font-size: 14pt;
    position: relative;
  }

  .layer-art-cert-vertical {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .layer-art-cert-vertical .inner {
    font-family: simsun;
    font-size: 14pt;
    color: #000;
    height: 297mm;
    width: 210mm;
    background-color: #eaeaea;
    margin: 0 auto;
    position: relative;
    line-height: 1.5;
  }

  .layer-art-cert-vertical .inner .label {
    line-height: 1.5;
  }

  .layer-art-cert-vertical .moveable {
    background: #d5ffc3;
    opacity: .8;
    cursor: pointer;
    position: absolute;
    z-index: 1;
  }

  .layer-art-cert-vertical .cell {
    display: -ms-inline-flexbox;
    display: inline-flex;
    position: absolute;
  }

  .layer-art-cert-vertical .cell .label .en {
    display: block;
    text-transform: uppercase;
  }

  .layer-art-cert-vertical .cell .label .en {

  }

  .layer-art-cert-vertical .cell .label .zh {

  }

  .QRcodeSet {
    border: 0px solid #000;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .photoSet {
    border: 0px solid #000;
    width: 147px;
    height: 197px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .toolbar {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, .9);
    font-size: 16px;
    width: 100%;
    padding: 10px;
    z-index: 9;
  }

  .toolbar select {
    font: inherit;
    padding: 5px;
    font-size: 14px;
  }

  .toolbar .handle {
    position: absolute;
    right: 30px;
  }

  .btn-print {
    font-size: 20px;
    padding: 5px 20px;
    cursor: pointer;
    background: gray;
    color: white;
    border: 1px solid #333;
  }

  .paper > .cell {
    page-break-after: always;
    padding: 70pt 0;
    margin: 0 auto;
  }

  .layer-art-cert-vertical .cell .label .zh:after,
  .layer-art-cert-vertical .cell .label .en:after {
    content: "："
  }


  @page {
    size: A4;
  }

  @media print {
    .paper > .cell {
      max-width: auto;
      padding: 0;
    }

    .layer-art-cert-vertical .cell {
      visibility: hidden;
    }

    .layer-art-cert-vertical .moveable,
    .layer-art-cert-vertical .inner {
      background: transparent;
    }

    .toolbar {
      display: none;
    }
  }

  .fontCn {
    font-family: 宋体;
    font-size: 14pt;
  }

  .fontEn {
    font-family: 宋体;
    font-size: 14pt;
  }

  .edit-country {
    font-size: 14pt;
    color: #000000;
    border: none;
    background-color: transparent;
    font-size: 14pt;
    width: 80%;
  }

</style>
